"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var page_1 = require("@shared/types/page");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (module) {
    var PAGE_LAYOUT = 'pageLayout';
    var HEIGHT = 'height';
    var WIDTH = 'width';
    module.factory('prPageLayoutService', [
        '$filter',
        '$injector',
        'prActiveReport',
        'prMetricImperial',
        'pr.globalOptionsService',
        function ($filter, $injector, report, metricImperial, globalOptionsService) {
            var translate = $filter('translate');
            var ALIGNMENTS = {
                none: {
                    label: translate('NONE'),
                    value: 'none'
                },
                left: {
                    label: translate('LEFT'),
                    value: 'left'
                },
                center: {
                    label: translate('CENTER'),
                    value: 'center'
                },
                right: {
                    label: translate('RIGHT'),
                    value: 'right'
                }
            };
            // keep a cached version so we don't do the merge every time
            var properties;
            var headerFooter; // we are going to use the injector... cause we have a circular dep...
            function getDefaultProperties() {
                return lodash_1.default.cloneDeep(page_1.DEFAULT_LAYOUT);
            }
            function getProperties(noClone) {
                if (properties) {
                    return noClone ? properties : lodash_1.default.cloneDeep(properties);
                }
                properties = lodash_1.default.defaultsDeep({}, report.getMetadata(PAGE_LAYOUT) || {}, page_1.DEFAULT_LAYOUT);
                properties = migrateLayout(properties, true);
                return properties;
            }
            /**
             * Migrates from the old 'slide' layout which is no longer supported.
             * @param  {[type]} pageLayout [description]
             * @param  {boolean} save 	   if true will save on migration
             * @return {[type]}            [description]
             */
            function migrateLayout(pageLayout, save) {
                if (pageLayout.size === 'slide') {
                    pageLayout.size = 'fullscreen';
                    // The orientations for the old 'slide' layout are incorrect.
                    if (pageLayout.orientation === "vertical" /* Vertical */) {
                        pageLayout.orientation = "horizontal" /* Horizontal */;
                    }
                    else {
                        pageLayout.orientation = "vertical" /* Vertical */;
                    }
                    if (save) {
                        setProperties(pageLayout);
                    }
                }
                return pageLayout;
            }
            function setProperties(props) {
                properties = lodash_1.default.cloneDeep(props);
                return report.setMetadata(PAGE_LAYOUT, props);
            }
            function getProperty(prop, noClone) {
                return getProperties(noClone)[prop];
            }
            /**
             * Gets the height and width of the page
             * as it appears to the user taking into account orientation.
             * @param {string} [layout] - if not provided, uses layout of active report
             * @return {object}
             *   @width {Number}
             *   @height {Number}
             */
            function getViewDimensions(layout) {
                layout = layout || {};
                var size = layout.size || getSize();
                var orientation = layout.orientation || getOrientation();
                var defaultDims = page_1.SIZES[size];
                var isSlide = (defaultDims.width >= defaultDims.height);
                var isVertical = (orientation === "vertical" /* Vertical */);
                if (isVertical !== isSlide) {
                    // Vertical and Page, or Horizontal and Slide
                    return {
                        width: defaultDims.width,
                        height: defaultDims.height
                    };
                }
                else {
                    // Horizontal and Page, or Vertical and Slide
                    return {
                        width: defaultDims.height,
                        height: defaultDims.width
                    };
                }
            }
            // always round width and height to the nearest cell value;
            function getWidth() {
                var viewSizes = getViewDimensions();
                return roundToCellSize((viewSizes[WIDTH]) * page_1.DEFAULT_DPI);
            }
            function getHeight() {
                var viewSizes = getViewDimensions();
                return roundToCellSize((viewSizes[HEIGHT]) * page_1.DEFAULT_DPI);
            }
            function getOrientation() {
                return getProperty('orientation', true);
            }
            function getSize() {
                return getProperty('size', true);
            }
            // always return margins as rounded to the nearest cell value
            function getMargins() {
                return lodash_1.default.mapValues(getProperty('margins', true), function (v) {
                    return roundToCellSize(v * page_1.DEFAULT_DPI);
                });
            }
            function roundToCellSize(value) {
                return Math.floor(value / page_1.DEFAULT_CELL_SIZE) * page_1.DEFAULT_CELL_SIZE;
            }
            function getCellSize() {
                return page_1.DEFAULT_CELL_SIZE;
            }
            function getSizeOptions(unit) {
                var sizeOptions = lodash_1.default.cloneDeep(page_1.SIZES);
                var useInch = metricImperial.useInch(unit);
                lodash_1.default.forEach(sizeOptions, function (size, key) {
                    var sizeName = translate(size.label || key.toUpperCase());
                    var widthVal = useInch ? size.width : metricImperial.getCMOfInch(size.width);
                    var heightVal = useInch ? size.height : metricImperial.getCMOfInch(size.height);
                    var unitLabel = useInch ? '"' : 'cm';
                    size.label = sizeName + ' (' + widthVal + unitLabel + ' x ' + heightVal + unitLabel + ')';
                });
                return sizeOptions;
            }
            function getCols() {
                var margins = getMargins();
                return Math.floor((getWidth() - margins.left - margins.right) / getCellSize());
            }
            function getRows() {
                var margins = getMargins();
                var hfHeights = getHeaderFooterHeights();
                return Math.floor((getHeight() - margins.top - margins.bottom
                    - hfHeights.header - hfHeights.footer) / getCellSize());
            }
            function getAlignments() {
                return ALIGNMENTS;
            }
            function getHeaderFooterHeights() {
                if (!headerFooter) {
                    headerFooter = $injector.get('prHeaderFooterService');
                }
                return {
                    header: headerFooter.getPXHeight('header'),
                    footer: headerFooter.getPXHeight('footer')
                };
            }
            function getSizeOfPage(pageType) {
                return page_1.SIZES[pageType];
            }
            /*
             * Not sure where to put this, but it makes the most sense here I think
             * It converts widget layout to CSS styles
             */
            function convertLayoutToStyle(layout) {
                var cellSize = getCellSize();
                var pageMargins = getMargins();
                var hfHeights = getHeaderFooterHeights();
                var rowOffset = (layout.page || 0) * getRows();
                return {
                    left: (layout.col * cellSize) + pageMargins.left,
                    top: ((layout.row - rowOffset) * cellSize) + pageMargins.top + hfHeights.header,
                    width: Math.max(layout.colSpan, 1) * cellSize,
                    height: Math.max(layout.rowSpan, 1) * cellSize
                };
            }
            function getWidgetWidth(widget) {
                var padding = globalOptionsService.getWidgetPaddingObj(widget.layout.padding);
                var BORDER_BUFFER = 1;
                var paddingBuffer = padding.left + padding.right;
                var width = widget.layout.colSpan * getCellSize() - BORDER_BUFFER - paddingBuffer;
                return width;
            }
            /*
             * Skipping the bounds checks means we are going to do it somewhere else
             */
            function convertStyleToLayout(css, prevLayout, skipBoundsCheck, limitHeight) {
                var page = prevLayout.page || 0;
                var cellSize = getCellSize();
                var cols = getCols();
                var rows = getRows();
                var pageMargins = getMargins();
                var mT = pageMargins.top;
                var mB = pageMargins.bottom;
                var mL = pageMargins.left;
                var hfHeights = getHeaderFooterHeights();
                var hH = hfHeights.header;
                // init layout to default values
                var layout = {
                    row: prevLayout.row,
                    rowSpan: prevLayout.rowSpan,
                    col: prevLayout.col,
                    colSpan: prevLayout.colSpan
                };
                if (css.hasOwnProperty('width')) {
                    var colSpanFromCss = Math.floor(css.width / cellSize);
                    var maxColSpan = cols - layout.col;
                    layout.colSpan = Math.min(colSpanFromCss, maxColSpan);
                }
                if (css.hasOwnProperty('height')) {
                    var rowSpanFromStyle = Math.floor(css.height / cellSize);
                    layout.rowSpan = limitHeight ? Math.min(rowSpanFromStyle, rows) : rowSpanFromStyle;
                }
                if (css.hasOwnProperty('left')) {
                    // it's 0 indexed
                    layout.col = Math.floor((css.left - mL) / cellSize);
                    // bounds checking
                    if (!skipBoundsCheck) {
                        layout.col = Math.min(Math.max(layout.col, 0), cols - layout.colSpan);
                    }
                }
                if (css.hasOwnProperty('top')) {
                    var PAGE_TOP_MARGIN = 32; // hardcoded, it is stupid
                    var topOffset = mT + hH;
                    var pageHeight = getHeight();
                    var height = css.height || layout.rowSpan * cellSize;
                    var cssAdjust = (css.top - topOffset > 0 ?
                        height - topOffset - PAGE_TOP_MARGIN - cellSize :
                        mB + PAGE_TOP_MARGIN);
                    var pageDiff = Math.floor((css.top + cssAdjust) / pageHeight);
                    var toPage = page + pageDiff;
                    var cssTop = (css.top - topOffset) - pageDiff * (topOffset + mB + PAGE_TOP_MARGIN);
                    var topRow = Math.floor(cssTop / cellSize);
                    var rowOffset = page * rows;
                    layout.row = Math.max(topRow + rowOffset, 0);
                    // bounds checking to make sure it stays on the right page
                    var toPageOffset = toPage * rows;
                    layout.row = Math.min(Math.max(layout.row, toPageOffset), toPageOffset + (rows - layout.rowSpan));
                }
                return lodash_1.default.merge({}, prevLayout, layout);
            }
            return {
                CELL_SIZE: page_1.DEFAULT_CELL_SIZE,
                PX_TO_IN: page_1.DEFAULT_DPI,
                getDefaultProperties: getDefaultProperties,
                getProperties: getProperties,
                getProperty: getProperty,
                getViewDimensions: getViewDimensions,
                setProperties: setProperties,
                getWidth: getWidth,
                getHeight: getHeight,
                getMargins: getMargins,
                getCellSize: getCellSize,
                getSizeOptions: getSizeOptions,
                getSizeOfPage: getSizeOfPage,
                getSize: getSize,
                getCols: getCols,
                getRows: getRows,
                getAlignments: getAlignments,
                getOrientation: getOrientation,
                migrateLayout: migrateLayout,
                convertLayoutToStyle: convertLayoutToStyle,
                convertStyleToLayout: convertStyleToLayout,
                getWidgetWidth: getWidgetWidth
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
